// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aeeb279c","453":"47ac61ba","732":"78137ee6"}[chunkId] + ".chunk.js";
};